import { Box } from "@mui/material";
import { ImageOrNode } from "Components/Shared/ImageOrNode";

type IconProps =
  | { iconUrl: string; icon?: never }
  | { iconUrl?: never; icon: React.ReactNode };

type Props = {
  backgroundImage?: string;
  isMobile: boolean;
} & IconProps;

export const PreviewHero = ({
  backgroundImage,
  isMobile,
  ...iconProps
}: Props) => (
  <Box
    display="flex"
    alignItems="flex-end"
    justifyContent="center"
    height={isMobile ? "200px" : "350px"}
    position="relative"
    mb={4}
    sx={{
      backgroundColor: "grey.300",
      ...(backgroundImage && {
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: "cover",
        backgroundPosition: "top",
        backgroundRepeat: "no-repeat",
      }),
      "&::after": {
        content: '""',
        position: "absolute",
        bottom: -1,
        left: -1,
        right: -1,
        height: "100px",
        background:
          "linear-gradient(to bottom, transparent 0%, rgba(255, 255, 255, 0.3) 40%, rgba(255, 255, 255, 0.8) 70%, #ffffff 100%)",
      },
    }}
  >
    <Box
      sx={{
        mb: -5,
        width: 42,
        height: 42,
        zIndex: 1,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        "& img": { objectFit: "contain", width: 42, height: 42 },
      }}
    >
      <ImageOrNode
        {...(iconProps.iconUrl
          ? { imageUrl: iconProps.iconUrl }
          : { image: iconProps.icon })}
      />
    </Box>
  </Box>
);
